"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Stack_1 = __importDefault(require("@mui/material/Stack"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const Popover_1 = __importDefault(require("@mui/material/Popover"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const utils_1 = require("../shared/utils");
const RemoveRedEye_1 = __importDefault(require("@mui/icons-material/RemoveRedEye"));
const FlagOutlined_1 = __importDefault(require("@mui/icons-material/FlagOutlined"));
const x_data_grid_1 = require("@mui/x-data-grid");
const styles_1 = require("@mui/material/styles");
const ReviewResult_1 = __importDefault(require("./ReviewResult"));
const diagnosticApi_1 = require("../services/diagnosticApi");
const dompurify_1 = __importDefault(require("dompurify"));
const services_1 = require("../services");
const apicall_1 = require("../shared/apicall");
const Fullscreen_1 = __importDefault(require("@mui/icons-material/Fullscreen"));
const CloseFullscreen_1 = __importDefault(require("@mui/icons-material/CloseFullscreen"));
const Refresh_1 = __importDefault(require("@mui/icons-material/Refresh"));
const react_1 = require("react");
const shared_1 = require("../shared");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const Fullscreen_2 = __importDefault(require("@mui/icons-material/Fullscreen"));
const FullscreenExit_1 = __importDefault(require("@mui/icons-material/FullscreenExit"));
const Snackbar_1 = __importDefault(require("@mui/material/Snackbar"));
const Alert_1 = __importDefault(require("@mui/material/Alert"));
const StyledDataGrid = (0, styles_1.styled)(x_data_grid_1.DataGrid)((theme) => ({
    '& .MuiDataGrid-sortIcon': {
        opacity: 1,
        color: 'white',
    },
    '& .MuiDataGrid-menuIconButton': {
        opacity: 1,
        color: 'white',
    },
}));
// Turns markdown links + bare URLs into <a>, then applies simple markdown
const createMarkup = (raw) => {
    if (!raw)
        return { __html: '' };
    let txt = raw
        .replace(/['"`]?\s*\+\s*['"`]?/g, '') // remove string-concat leftovers
        .replace(/\\n/g, '<br>'); // \n -> <br>
    // 1) [text](url) -> <a>
    txt = txt.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
    txt = txt.replace(/(^|[\s(>])((?:https?:\/\/)[\w\-./?#[\]@!$&'()*+,;=%]+)(?=$|[\s<)])/g, '$1<a href="$2" target="_blank" rel="noopener noreferrer">$2</a>');
    txt = txt
        .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>') // **bold**
        // _italics_ only when underscores are surrounded by space/punct
        .replace(/(^|[\s>~(])_(.+?)_(?=[$\s,.!?)<])/g, '$1<em>$2</em>');
    return { __html: dompurify_1.default.sanitize(txt, { ADD_ATTR: ['target', 'rel'] }) };
};
// Helper function to format answer choices
const formatAnswerChoices = (answerChoices) => {
    if (!Array.isArray(answerChoices))
        return '';
    return answerChoices
        .map((choice, index) => {
        const letter = String.fromCharCode(97 + index);
        return `${letter}. ${choice.Description || ''}`;
    })
        .join('\n');
};
// Helper to check if smartAnalysis is valid and complete
const isSmartAnalysisComplete = (analysis) => {
    if (!analysis)
        return false;
    let parsed = null;
    if (typeof analysis === 'string') {
        // Try JSON parse first
        try {
            parsed = JSON.parse(analysis);
        }
        catch (_a) {
            // Try to extract fields with regex as a fallback
            const readingMatch = analysis.match(/ReadingAndWriting\s*[:=]\s*['"]([^'"]+)['"]/);
            const mathMatch = analysis.match(/Math\s*[:=]\s*['"]([^'"]+)['"]/);
            parsed = {};
            if (readingMatch)
                parsed.ReadingAndWriting = readingMatch[1];
            if (mathMatch)
                parsed.Math = mathMatch[1];
        }
    }
    else {
        parsed = analysis;
    }
    // At least one of the fields must be present and non-empty
    return !!((parsed && parsed.ReadingAndWriting) || (parsed && parsed.Math));
};
const ResultGrid = ({ id, data, quiz, header, userName, testName, completeDate, filterValue, flaggedQns, setFlaggedQns, refetch, bluebookSections }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    const sectionMap = bluebookSections === null || bluebookSections === void 0 ? void 0 : bluebookSections.reduce((acc, item) => {
        acc[item.id] = item.section;
        return acc;
    }, {});
    // Calculate the total questions
    const total = id === 0
        ? ((_a = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _a === void 0 ? void 0 : _a.isBlueBookData)
            ? (_c = (_b = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _b === void 0 ? void 0 : _b.summary) === null || _c === void 0 ? void 0 : _c.totalQuestions // For BlueBookData, use totalQuestions from summary
            : (0, utils_1.getOverAllScore)(data === null || data === void 0 ? void 0 : data.diagnostic, data === null || data === void 0 ? void 0 : data.questions).count // For non-BlueBookData, use overall score count
        : ((_d = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _d === void 0 ? void 0 : _d.isBlueBookData) && sectionMap[id]
            ? (_e = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _e === void 0 ? void 0 : _e.bluebookData.filter((item) => item.questionData.section === sectionMap[id]).length // Match section based on id // Count the number of questions in the section
            : (0, utils_1.getScore)((_f = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _f === void 0 ? void 0 : _f.questions[id], (_g = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _g === void 0 ? void 0 : _g.answers, data === null || data === void 0 ? void 0 : data.questions).count; // Fallback for other cases
    // Calculate correct answers dynamically based on section mapping
    const correct = id === 0
        ? ((_h = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _h === void 0 ? void 0 : _h.isBlueBookData)
            ? (_k = (_j = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _j === void 0 ? void 0 : _j.summary) === null || _k === void 0 ? void 0 : _k.correctAnswers // For BlueBookData, use correctAnswers from summary
            : (0, utils_1.getOverAllScore)(data === null || data === void 0 ? void 0 : data.diagnostic, data === null || data === void 0 ? void 0 : data.questions).correctCount // For non-BlueBookData, use overall correct count
        : ((_l = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _l === void 0 ? void 0 : _l.isBlueBookData) && sectionMap[id]
            ? (_m = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _m === void 0 ? void 0 : _m.bluebookData.filter((item) => item.questionData.section === sectionMap[id]).reduce((count, item) => {
                const isCorrect = item.questionData.yourAnswer.includes('Correct');
                return count + (isCorrect ? 1 : 0); // Increment count for correct answers
            }, 0) // Start count at 0
            : (0, utils_1.getScore)((_o = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _o === void 0 ? void 0 : _o.questions[id], (_p = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _p === void 0 ? void 0 : _p.answers, data === null || data === void 0 ? void 0 : data.questions).correctCount; // Fallback for other cases
    const getQuiz = (id) => {
        var _a;
        const test = quiz === null || quiz === void 0 ? void 0 : quiz.find((x) => `${x.id}` === `${id}`);
        return ((_a = test === null || test === void 0 ? void 0 : test.attributes) === null || _a === void 0 ? void 0 : _a.Name) || '';
    };
    const getSection = (id) => {
        var _a, _b, _c, _d;
        const test = quiz === null || quiz === void 0 ? void 0 : quiz.find((x) => `${x.id}` === `${id}`);
        return ((_d = (_c = (_b = (_a = test === null || test === void 0 ? void 0 : test.attributes) === null || _a === void 0 ? void 0 : _a.DiagnosticsArea) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.attributes) === null || _d === void 0 ? void 0 : _d.Name) || '';
    };
    console.log('data', data);
    const getBlueBookRowdata = () => {
        var _a;
        let questionList = [];
        const bluebookData = (_a = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _a === void 0 ? void 0 : _a.bluebookData;
        if (Array.isArray(bluebookData)) {
            let sectionMap = {
                0: null
            };
            sectionMap = Object.assign(Object.assign({}, sectionMap), bluebookSections === null || bluebookSections === void 0 ? void 0 : bluebookSections.reduce((acc, item) => {
                acc[item.id] = item.section;
                return acc;
            }, {}));
            const selectedSection = sectionMap[id];
            bluebookData.forEach((item, index) => {
                const attributes = item === null || item === void 0 ? void 0 : item.attributes;
                const questionData = item === null || item === void 0 ? void 0 : item.questionData;
                if (attributes && questionData) {
                    if (!selectedSection || questionData.section === selectedSection) {
                        const isCorrect = !questionData.yourAnswer.includes('Incorrect');
                        const questionEntry = {
                            id: `q-${index + 1}`,
                            questionId: `q-${index + 1}`,
                            questionOrder: attributes.QuestionNumber,
                            sectionId: id,
                            section: questionData.section,
                            module: attributes.Module,
                            correctAnswer: questionData.correctAnswer,
                            yourAnswer: questionData.yourAnswer,
                            isCorrect,
                            subType: attributes.ContentDomain,
                            kahnAcademyType: attributes.KhanAcademyType,
                            type: attributes.AlphaPrepSubtype,
                            difficulty: attributes.Difficulty,
                            khanAcademyLink: attributes.LinkToModule,
                            questionContent: questionData.questionText || '',
                            answerChoices: questionData.answerChoices ? questionData.answerChoices.map((choice, idx) => `${(idx + 10).toString(36).toUpperCase()}) ${choice}`).join('\n') : '',
                        };
                        questionList.push(questionEntry);
                    }
                }
            });
        }
        else {
            console.warn('No valid bluebookData available');
        }
        return questionList;
    };
    const getRowData = () => {
        var _a, _b, _c, _d, _e;
        let questionList = [];
        if (id === 0) {
            Object.keys(((_a = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _a === void 0 ? void 0 : _a.questions) || {}).map((x) => {
                var _a, _b;
                const qData = Object.values(((_b = (_a = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _a === void 0 ? void 0 : _a.questions[x]) === null || _b === void 0 ? void 0 : _b.questions) || []);
                (qData || []).map((i, idx) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                    const ans = (_b = (_a = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _a === void 0 ? void 0 : _a.answers) === null || _b === void 0 ? void 0 : _b.find((a) => a.questionId === i);
                    const quest = data === null || data === void 0 ? void 0 : data.questions[i];
                    let correctAnswer;
                    let selectedAnswer = (ans === null || ans === void 0 ? void 0 : ans.answer) ? ans === null || ans === void 0 ? void 0 : ans.answer : '';
                    let isCorrect;
                    if ((quest === null || quest === void 0 ? void 0 : quest.QuestionType) === 'choice') {
                        const correctIndex = (_c = quest === null || quest === void 0 ? void 0 : quest.AnswerChoices) === null || _c === void 0 ? void 0 : _c.findIndex((ac) => ac.IsCorrect);
                        correctAnswer = ((_e = (_d = (correctIndex + 10)) === null || _d === void 0 ? void 0 : _d.toString(36)) === null || _e === void 0 ? void 0 : _e.toUpperCase()) || '';
                        selectedAnswer = ans ? ((_g = (_f = ((ans === null || ans === void 0 ? void 0 : ans.selectedChoice) + 10)) === null || _f === void 0 ? void 0 : _f.toString(36)) === null || _g === void 0 ? void 0 : _g.toUpperCase()) || '' : '';
                        isCorrect = ans ? correctIndex === (ans === null || ans === void 0 ? void 0 : ans.selectedChoice) : false;
                    }
                    else if (((quest === null || quest === void 0 ? void 0 : quest.QuestionType) === 'number' || (quest === null || quest === void 0 ? void 0 : quest.QuestionType) === 'text') && (quest === null || quest === void 0 ? void 0 : quest.CorrectAnswer)) {
                        correctAnswer = quest === null || quest === void 0 ? void 0 : quest.CorrectAnswer.map((i) => {
                            return i['Answer'];
                        }).join(' (or) ');
                        isCorrect = (_h = quest === null || quest === void 0 ? void 0 : quest.CorrectAnswer) === null || _h === void 0 ? void 0 : _h.some((i) => { var _a; return i.Answer.toLowerCase() === ((_a = ans === null || ans === void 0 ? void 0 : ans.answer) === null || _a === void 0 ? void 0 : _a.toLowerCase()); });
                    }
                    questionList.push({
                        id: `${x}${i}`,
                        questionId: i,
                        questionOrder: idx + 1,
                        sectionId: x,
                        section: getSection(x) || '',
                        module: getQuiz(x) || '',
                        correctAnswer: correctAnswer,
                        yourAnswer: ans && (((quest === null || quest === void 0 ? void 0 : quest.QuestionType) === 'choice' && ((_j = ans === null || ans === void 0 ? void 0 : ans.selectedChoice) === null || _j === void 0 ? void 0 : _j.toString())) || ((quest === null || quest === void 0 ? void 0 : quest.QuestionType) !== 'choice' && (ans === null || ans === void 0 ? void 0 : ans.answer)))
                            ? isCorrect
                                ? `${selectedAnswer}; Correct`
                                : `${selectedAnswer}; Incorrect`
                            : 'Omitted',
                        isCorrect: isCorrect,
                        subType: (quest === null || quest === void 0 ? void 0 : quest.SubType) || '',
                        kahnAcademyType: (quest === null || quest === void 0 ? void 0 : quest.KahnAcademyType) || '',
                        type: ((_k = quest === null || quest === void 0 ? void 0 : quest.Type) === null || _k === void 0 ? void 0 : _k.name) || '',
                        difficulty: ((_l = quest === null || quest === void 0 ? void 0 : quest.Difficulty) === null || _l === void 0 ? void 0 : _l.name) || '',
                        question: (quest === null || quest === void 0 ? void 0 : quest.Question) || '',
                        description: (quest === null || quest === void 0 ? void 0 : quest.Description) || '',
                        answerChoices: formatAnswerChoices(quest === null || quest === void 0 ? void 0 : quest.AnswerChoices),
                        explanation: (quest === null || quest === void 0 ? void 0 : quest.Explanation) || '',
                    });
                });
            });
        }
        else if ((_c = (_b = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _b === void 0 ? void 0 : _b.questions[id]) === null || _c === void 0 ? void 0 : _c.questions) {
            const qData = Object.values(((_e = (_d = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _d === void 0 ? void 0 : _d.questions[id]) === null || _e === void 0 ? void 0 : _e.questions) || []);
            (qData || []).map((i, idx) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                const ans = (_b = (_a = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _a === void 0 ? void 0 : _a.answers) === null || _b === void 0 ? void 0 : _b.find((a) => a.questionId === i);
                const quest = data === null || data === void 0 ? void 0 : data.questions[i];
                let correctAnswer;
                let selectedAnswer = (ans === null || ans === void 0 ? void 0 : ans.answer) ? ans === null || ans === void 0 ? void 0 : ans.answer : '';
                let isCorrect;
                if ((quest === null || quest === void 0 ? void 0 : quest.QuestionType) === 'choice') {
                    const correctIndex = (_c = quest === null || quest === void 0 ? void 0 : quest.AnswerChoices) === null || _c === void 0 ? void 0 : _c.findIndex((ac) => ac.IsCorrect);
                    correctAnswer = ((_e = (_d = (correctIndex + 10)) === null || _d === void 0 ? void 0 : _d.toString(36)) === null || _e === void 0 ? void 0 : _e.toUpperCase()) || '';
                    selectedAnswer = ans ? ((_g = (_f = ((ans === null || ans === void 0 ? void 0 : ans.selectedChoice) + 10)) === null || _f === void 0 ? void 0 : _f.toString(36)) === null || _g === void 0 ? void 0 : _g.toUpperCase()) || '' : '';
                    isCorrect = ans ? correctIndex === (ans === null || ans === void 0 ? void 0 : ans.selectedChoice) : false;
                }
                else if ((quest === null || quest === void 0 ? void 0 : quest.QuestionType) === 'number' || ((quest === null || quest === void 0 ? void 0 : quest.QuestionType) === 'text' && (quest === null || quest === void 0 ? void 0 : quest.CorrectAnswer))) {
                    correctAnswer = quest === null || quest === void 0 ? void 0 : quest.CorrectAnswer.map((i) => {
                        return i['Answer'];
                    }).join(' (or) ');
                    isCorrect = (_h = quest === null || quest === void 0 ? void 0 : quest.CorrectAnswer) === null || _h === void 0 ? void 0 : _h.some((i) => { var _a; return i.Answer.toLowerCase() === ((_a = ans === null || ans === void 0 ? void 0 : ans.answer) === null || _a === void 0 ? void 0 : _a.toLowerCase()); });
                }
                questionList.push({
                    id: `${id}${i}`,
                    questionId: i,
                    questionOrder: idx + 1,
                    sectionId: id,
                    section: getSection(id) || '',
                    module: getQuiz(id) || '',
                    correctAnswer: correctAnswer,
                    yourAnswer: ans && (((quest === null || quest === void 0 ? void 0 : quest.QuestionType) === 'choice' && ((_j = ans === null || ans === void 0 ? void 0 : ans.selectedChoice) === null || _j === void 0 ? void 0 : _j.toString())) || ((quest === null || quest === void 0 ? void 0 : quest.QuestionType) !== 'choice' && (ans === null || ans === void 0 ? void 0 : ans.answer)))
                        ? isCorrect
                            ? `${selectedAnswer}; Correct`
                            : `${selectedAnswer}; Incorrect`
                        : 'Omitted',
                    isCorrect: isCorrect,
                    subType: (quest === null || quest === void 0 ? void 0 : quest.SubType) || '',
                    kahnAcademyType: (quest === null || quest === void 0 ? void 0 : quest.KahnAcademyType) || '',
                    type: ((_k = quest === null || quest === void 0 ? void 0 : quest.Type) === null || _k === void 0 ? void 0 : _k.name) || '',
                    difficulty: ((_l = quest === null || quest === void 0 ? void 0 : quest.Difficulty) === null || _l === void 0 ? void 0 : _l.name) || '',
                    question: (quest === null || quest === void 0 ? void 0 : quest.Question) || '',
                    description: (quest === null || quest === void 0 ? void 0 : quest.Description) || '',
                    answerChoices: formatAnswerChoices(quest === null || quest === void 0 ? void 0 : quest.AnswerChoices),
                    explanation: (quest === null || quest === void 0 ? void 0 : quest.Explanation) || '',
                });
            });
        }
        console.log('questionList', questionList);
        return questionList;
    };
    console.log('data', data);
    const apiRef = React.useRef(null);
    const [selected, setSelected] = React.useState({});
    const [showReview, setShowReview] = React.useState(false);
    const handleReviewAction = (param) => {
        setSelected(param);
        setShowReview(true);
    };
    const [addFlaggedQuestion] = (0, diagnosticApi_1.useFlaggedQuestionMutation)();
    const [selectedQuestion, setSelectedQuestion] = React.useState({});
    const [firstLoad, setFirstLoad] = React.useState(true);
    const [feedback, setFeedback] = React.useState(null);
    const [updateSmartAnalysis, { isLoading: isCreating }] = (0, services_1.useUpdateSmartAnalysisMutation)();
    const [expandedSection, setExpandedSection] = React.useState(null);
    // Replace analysisRequested state with a ref
    const analysisRequested = React.useRef(null);
    const [showSmartAnalysis, setShowSmartAnalysis] = React.useState(isSmartAnalysisComplete((_q = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _q === void 0 ? void 0 : _q.smartAnalysis));
    const [smartLoading, setSmartLoading] = React.useState(!isSmartAnalysisComplete((_r = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _r === void 0 ? void 0 : _r.smartAnalysis));
    const [pdfDialogOpen, setPdfDialogOpen] = React.useState(false);
    const [pdfUrl, setPdfUrl] = React.useState('');
    const [htmlContent, setHtmlContent] = (0, react_1.useState)('');
    const [fileType, setFileType] = (0, react_1.useState)('');
    const [excelData, setExcelData] = (0, react_1.useState)([]);
    const [alertOpen, setAlertOpen] = React.useState(false);
    const [alertMessage, setAlertMessage] = React.useState('');
    const [isMaximized, setIsMaximized] = (0, react_1.useState)(false);
    const handleToggleSize = () => {
        setIsMaximized((prev) => !prev);
    };
    const handleSnackBarOpen = (message = 'No Guides available') => {
        setAlertMessage(message);
        setAlertOpen(true);
    };
    const handleSnackBarClose = () => {
        setAlertOpen(false);
        setAlertMessage('');
    };
    const handleGuideClick = async (typeValue) => {
        try {
            //let typeValue = "Vocab in Context";
            //const guide = await getStrapiData(`guides?filters[question_type][Name]][$eqi]=${typeValue}&populate=*`)
            const guide = await (0, shared_1.getStrapiData)(`guides?filters[$or][0][question_type][Name]][$eqi]=${typeValue}&filters[$or][1][area_sub_type][name]][$eqi]=${typeValue}&populate=*`);
            if (guide.length === 0) {
                handleSnackBarOpen('No Guides available');
            }
            else {
                const pdfPath = guide[0].attributes.Document.data.attributes.url;
                const parts = pdfPath.split('.');
                const extension = parts[parts.length - 1].toLowerCase();
                setFileType(extension);
                const contentAPI = await (0, shared_1.getCmsURL)();
                const fullPdfUrl = `${contentAPI}${pdfPath}`;
                if (extension === 'docx') {
                    const fullDocxUrl = `https://view.officeapps.live.com/op/view.aspx?src=${contentAPI}${pdfPath}&wdOrigin=BROWSELINK`;
                    setPdfUrl(fullDocxUrl);
                    setPdfDialogOpen(true);
                }
                else if (extension == 'pdf') {
                    setPdfUrl(fullPdfUrl);
                    setPdfDialogOpen(true);
                }
                else {
                    try {
                        // const response = await fetch(fullPdfUrl);
                        // const blob = await response.blob();
                        // const arrayBuffer = await blob.arrayBuffer();
                        // const workbook = XLSX.read(arrayBuffer, { type: 'array' });
                        // const sheetName = workbook.SheetNames[0];
                        // const worksheet = workbook.Sheets[sheetName];
                        // const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                        // setExcelData(jsonData);
                        const fullExcelUrl = `https://view.officeapps.live.com/op/view.aspx?src=${contentAPI}${pdfPath}&wdOrigin=BROWSELINK`;
                        setPdfUrl(fullExcelUrl);
                        setPdfDialogOpen(true);
                    }
                    catch (error) {
                        console.error('Error loading Excel file:', error);
                    }
                }
                console.log('fullPdfUrl ', fullPdfUrl);
                //setPdfUrl(fullPdfUrl);
                setPdfDialogOpen(true);
            }
        }
        catch (error) {
            console.error('Error fetching PDF:', error);
        }
    };
    const handleFlagAction = async (param) => {
        var _a, _b, _c;
        setFlaggedQns((prevItems) => {
            var _a;
            const existingItemIndex = flaggedQns.findIndex((item) => parseInt(item.id) === parseInt(selectedQuestion === null || selectedQuestion === void 0 ? void 0 : selectedQuestion.questionId));
            let newItem = {
                id: ((_a = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _a === void 0 ? void 0 : _a.isBlueBookData) ? parseInt(selectedQuestion === null || selectedQuestion === void 0 ? void 0 : selectedQuestion.questionOrder) : parseInt(selectedQuestion === null || selectedQuestion === void 0 ? void 0 : selectedQuestion.questionId),
                type: param,
                section: selectedQuestion === null || selectedQuestion === void 0 ? void 0 : selectedQuestion.section,
            };
            if (existingItemIndex >= 0) {
                const updatedItems = [...prevItems, { type: param }];
                updatedItems[existingItemIndex] = Object.assign(Object.assign({}, updatedItems[existingItemIndex]), newItem);
                return updatedItems;
            }
            else {
                return [...prevItems, newItem];
            }
        });
        let quizId = (_a = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _a === void 0 ? void 0 : _a.quizId;
        let questionDetail = selectedQuestion;
        questionDetail['flagType'] = param;
        questionDetail['isBlueBook'] = (_b = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _b === void 0 ? void 0 : _b.isBlueBookData;
        if ((_c = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _c === void 0 ? void 0 : _c.isBlueBookData) {
            questionDetail['questionId'] = selectedQuestion === null || selectedQuestion === void 0 ? void 0 : selectedQuestion.questionOrder;
        }
        await addFlaggedQuestion({ body: { quizId: quizId, flaggedQuestion: questionDetail, mode: '' } }).unwrap();
        setSelectedQuestion({});
        setAnchorEl(null);
    };
    const checkForFlag = (param) => {
        if (flaggedQns.some((el) => el.id === parseInt(param === null || param === void 0 ? void 0 : param.row.questionId))) {
            return flaggedQns.find((a) => a.id === parseInt(param === null || param === void 0 ? void 0 : param.row.questionId)).type;
        }
        return 'none';
    };
    const checkForFlagBluebook = (param) => {
        if (flaggedQns.some((el) => el.id === parseInt(param === null || param === void 0 ? void 0 : param.row.questionOrder) && el.section === (param === null || param === void 0 ? void 0 : param.row.section))) {
            return flaggedQns.find((a) => a.id === parseInt(param === null || param === void 0 ? void 0 : param.row.questionOrder) && a.section === (param === null || param === void 0 ? void 0 : param.row.section)).type;
        }
        return 'none';
    };
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [typeAnchorEl, setTypeAnchorEl] = React.useState(null);
    const [selectedType, setSelectedType] = React.useState('');
    const handleClick = async (event, param) => {
        setSelectedQuestion(param);
        setAnchorEl(event.currentTarget);
    };
    const handleTypeClick = (event, type) => {
        setSelectedType(type);
        setTypeAnchorEl(event.currentTarget);
    };
    const handleTypeClose = () => {
        setTypeAnchorEl(null);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const typeOpen = Boolean(typeAnchorEl);
    const idpopup = open ? 'simple-popover' : undefined;
    const typeIdpopup = typeOpen ? 'type-popover' : undefined;
    const rows = ((_s = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _s === void 0 ? void 0 : _s.isBlueBookData) ? getBlueBookRowdata() : getRowData();
    const columns = [
        {
            field: 'questionOrder',
            headerName: 'Question #',
            maxWidth: 80,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'section',
            headerName: 'Section',
            minWidth: 100,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'module',
            headerName: 'Module',
            minWidth: 100,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'subType',
            headerName: 'College Board Domain',
            minWidth: 100,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: (e) => handleGuideClick(params.value), style: { color: 'blue', textTransform: 'none', justifyContent: 'flex-start', textDecoration: 'underline', cursor: 'pointer' } }, { children: params.value }))),
        },
        {
            field: 'type',
            headerName: 'Alphaprep Type',
            minWidth: 100,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: (e) => handleGuideClick(params.value), style: { color: 'blue', textTransform: 'none', justifyContent: 'flex-start', textDecoration: 'underline', cursor: 'pointer' } }, { children: params.value }))),
        },
        {
            field: 'kahnAcademyType',
            headerName: 'Kahn Academy Type',
            minWidth: 100,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'difficulty',
            headerName: 'Difficulty',
            minWidth: 100,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'correctAnswer',
            headerName: 'Correct Answer',
            minWidth: 100,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'yourAnswer',
            headerName: 'Your Answer',
            minWidth: 100,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            cellClassName: (params) => {
                if (params.value === 'Omitted') {
                    return 'result_grid_wrong_answer';
                }
                if (params.value && params.row.isCorrect) {
                    return 'result_grid_correct_answer';
                }
                return 'result_grid_wrong_answer';
            },
        },
        {
            field: 'flag',
            headerName: 'Flag',
            minWidth: 100,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                var _a;
                if ((_a = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _a === void 0 ? void 0 : _a.isBlueBookData) {
                    let res = checkForFlagBluebook(params);
                    if (res != 'none') {
                        let flagColor = res === 'help' || res === 'nudge' ? (res === 'help' ? 'red' : 'orange') : '#70D291';
                        return ((0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ title: res.toUpperCase() }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ variant: 'contained', sx: { borderRadius: 5, margin: 1, color: 'black', backgroundColor: flagColor, ':hover': { backgroundColor: flagColor } }, onClick: (e) => handleClick(e, params.row) }, { children: (0, jsx_runtime_1.jsx)(FlagOutlined_1.default, {}) })) })));
                    }
                    else {
                        return ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ variant: 'contained', sx: { borderRadius: 5, margin: 1, color: 'black', backgroundColor: 'white', ':hover': { backgroundColor: 'white' } }, onClick: (e) => handleClick(e, params.row) }, { children: (0, jsx_runtime_1.jsx)(FlagOutlined_1.default, {}) })));
                    }
                }
                else {
                    let res = checkForFlag(params);
                    if (res != 'none') {
                        let flagColor = res === 'help' || res === 'nudge' ? (res === 'help' ? 'red' : 'orange') : '#70D291';
                        return ((0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ title: res.toUpperCase() }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ variant: 'contained', sx: { borderRadius: 5, margin: 1, color: 'black', backgroundColor: flagColor, ':hover': { backgroundColor: flagColor } }, onClick: (e) => handleClick(e, params.row) }, { children: (0, jsx_runtime_1.jsx)(FlagOutlined_1.default, {}) })) })));
                    }
                    else {
                        return ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ variant: 'contained', sx: { borderRadius: 5, margin: 1, color: 'black', backgroundColor: 'white', ':hover': { backgroundColor: 'white' } }, onClick: (e) => handleClick(e, params.row) }, { children: (0, jsx_runtime_1.jsx)(FlagOutlined_1.default, {}) })));
                    }
                }
            },
            filterable: true,
            valueGetter: (params) => {
                var _a;
                if ((_a = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _a === void 0 ? void 0 : _a.isBlueBookData) {
                    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
                }
                else {
                    let res = checkForFlag(params);
                    if (res != 'none') {
                        return res;
                    }
                    else {
                        return '';
                    }
                }
            },
        },
        {
            field: 'action',
            headerName: 'Actions',
            headerAlign: 'center',
            minWidth: 150,
            renderCell: (params) => {
                var _a;
                if ((_a = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _a === void 0 ? void 0 : _a.isBlueBookData) {
                    // Link rendering if isbluebookdata is true
                    return ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ color: 'primary', variant: 'contained', sx: { borderRadius: 20, margin: 1 }, onClick: () => window.open(params.row.khanAcademyLink, '_blank') }, { children: "Link" })));
                }
                else {
                    // Review button rendering if isbluebookdata is false
                    return ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ color: 'primary', variant: 'contained', sx: { borderRadius: 20, margin: 1 }, onClick: () => handleReviewAction(params.row), endIcon: (0, jsx_runtime_1.jsx)(RemoveRedEye_1.default, {}) }, { children: "Review" })));
                }
            },
        },
    ];
    const handleFilter = (field, operator, value) => {
        if (apiRef.current) {
            apiRef.current.setFilterModel({
                items: [{ field: field, operator: operator, value: value }],
            });
        }
    };
    const handlePdfDialogClose = () => {
        setPdfDialogOpen(false);
        setPdfUrl('');
        setIsMaximized(false);
    };
    React.useEffect(() => {
        var _a;
        if (firstLoad) {
            // Filter logic
            if (filterValue !== '' && filterValue !== undefined) {
                const array = filterValue.split('~').map(String);
                handleFilter(array[0], array[1], array[2]);
            }
            // Flagged question setup
            if ((_a = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _a === void 0 ? void 0 : _a.flaggedQuestions) {
                data.diagnostic.flaggedQuestions.forEach((q) => {
                    setFlaggedQns((prevItems) => {
                        const existingItemIndex = prevItems.findIndex((item) => parseInt(item.id) === parseInt(q.questionId));
                        const newItem = {
                            id: parseInt(q.questionId),
                            type: q.flagType,
                            section: q.section,
                        };
                        if (existingItemIndex >= 0) {
                            const updatedItems = [...prevItems];
                            updatedItems[existingItemIndex] = Object.assign(Object.assign({}, updatedItems[existingItemIndex]), newItem);
                            return updatedItems;
                        }
                        else {
                            return [...prevItems, newItem];
                        }
                    });
                });
            }
            // Prevent re-running
            setFirstLoad(false);
        }
    }, [firstLoad]);
    console.log('data for testname', data);
    const sendAnalysisData = async () => {
        var _a, _b, _c, _d, _e;
        setSmartLoading(true);
        let analysisList = [];
        try {
            if (rows.length > 0) {
                rows.forEach((row) => {
                    analysisList.push({
                        questionNumber: row.questionOrder,
                        correctAnswer: row.correctAnswer,
                        difficulty: row.difficulty,
                        isCorrect: row.isCorrect,
                        section: row.section,
                        alphaPrepType: row.type,
                        yourAnswer: row.yourAnswer,
                        kahnAcademyType: row.kahnAcademyType,
                        collegeBoardDomain: row.subType,
                        module: row.module,
                    });
                });
            }
            console.log({ rows, analysisList });
            console.log('data.testtype', (_a = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _a === void 0 ? void 0 : _a.testtype);
            const feedbackUrl = `${(0, apicall_1.getFeedbackApiUrl)()}/smart-analysis/generate-feedback` +
                `?testType=${encodeURIComponent(((_b = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _b === void 0 ? void 0 : _b.testtype) || '')}` +
                `&isfulllength=${encodeURIComponent(String((_d = (_c = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _c === void 0 ? void 0 : _c.type) !== null && _d !== void 0 ? _d : ''))}`;
            console.log('feedback', feedbackUrl);
            const response = await fetch(feedbackUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(analysisList),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const feedback = await response.json();
            console.log('Feedback from API:', feedback);
            setFeedback(feedback);
            // Save smart analysis to backend
            const smartPayload = {
                ReadingAndWriting: feedback['Reading & Writing'] || '',
                Math: feedback['Math'] || '',
            };
            const quizId = (_e = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _e === void 0 ? void 0 : _e.quizId;
            if (quizId) {
                try {
                    await updateSmartAnalysis({
                        quizId,
                        data: smartPayload,
                    }).unwrap();
                    if (refetch)
                        refetch(); // Refetch parent data after saving smart analysis
                }
                catch (err) {
                    console.error('Error saving smart analysis:', err);
                }
            }
        }
        catch (error) {
            console.error('Error sending analysis data:', error);
            // Show error snackbar
            handleSnackBarOpen('An error occurred while generating the smart analysis data, loading the previously saved data instead.');
        }
        finally {
            setSmartLoading(false);
        }
    };
    React.useEffect(() => {
        var _a, _b;
        const quizId = (_a = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _a === void 0 ? void 0 : _a.quizId;
        if (quizId && !isSmartAnalysisComplete((_b = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _b === void 0 ? void 0 : _b.smartAnalysis) && analysisRequested.current !== quizId) {
            setSmartLoading(true);
            setShowSmartAnalysis(false);
            analysisRequested.current = quizId;
            sendAnalysisData();
        }
    }, [(_t = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _t === void 0 ? void 0 : _t.smartAnalysis, (_u = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _u === void 0 ? void 0 : _u.quizId]);
    // Remove the effect that resets analysisRequested on quizId change, as useRef persists across re-mounts
    // Show smart analysis only when it is complete in the data prop
    React.useEffect(() => {
        var _a;
        if (isSmartAnalysisComplete((_a = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _a === void 0 ? void 0 : _a.smartAnalysis)) {
            setSmartLoading(false);
            setShowSmartAnalysis(true);
        }
    }, [(_v = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _v === void 0 ? void 0 : _v.smartAnalysis]);
    // Add this after isSmartAnalysisComplete and before rendering
    let parsedSmartAnalysis = null;
    const smartAnalysis = (_w = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _w === void 0 ? void 0 : _w.smartAnalysis;
    if (smartAnalysis) {
        if (typeof smartAnalysis === 'string') {
            try {
                parsedSmartAnalysis = JSON.parse(smartAnalysis);
                console.log('parsedSmartAnalysis-string', parsedSmartAnalysis);
            }
            catch (error) {
                console.log('error parsing smart analysis:', error);
                parsedSmartAnalysis = {};
                // Helper function to extract and combine template literal strings
                const extractTemplateLiteral = (fieldName, str) => {
                    // Find the field name position
                    const fieldPattern = new RegExp(`${fieldName}\\s*[:=]\\s*`, 'm');
                    const fieldMatch = str.match(fieldPattern);
                    if (!fieldMatch)
                        return null;
                    let pos = fieldMatch.index + fieldMatch[0].length;
                    let content = '';
                    let inString = false;
                    let stringChar = ''; // '`', "'", or '"'
                    let escapeNext = false;
                    // Parse the string value
                    while (pos < str.length) {
                        const char = str[pos];
                        if (escapeNext) {
                            content += char;
                            escapeNext = false;
                            pos++;
                            continue;
                        }
                        if (char === '\\') {
                            escapeNext = true;
                            if (inString) {
                                content += char;
                            }
                            pos++;
                            continue;
                        }
                        // Check for string delimiters
                        if ((char === '`' || char === "'" || char === '"') && !escapeNext) {
                            if (!inString) {
                                // Opening quote/backtick
                                inString = true;
                                stringChar = char;
                                pos++;
                                continue;
                            }
                            else if (char === stringChar) {
                                // Closing quote/backtick
                                inString = false;
                                stringChar = '';
                                pos++;
                                // Check if there's concatenation (+)
                                const remaining = str.substring(pos).trim();
                                if (remaining.startsWith('+')) {
                                    // Skip + and whitespace, continue parsing next string part
                                    const plusIndex = str.indexOf('+', pos);
                                    if (plusIndex !== -1) {
                                        pos = plusIndex + 1;
                                        // Skip whitespace after +
                                        while (pos < str.length && /\s/.test(str[pos]))
                                            pos++;
                                        continue;
                                    }
                                    else {
                                        // No + found, we're done
                                        break;
                                    }
                                }
                                else {
                                    // No more concatenation, we're done
                                    break;
                                }
                            }
                            else {
                                // Different quote type inside string - treat as content
                                if (inString)
                                    content += char;
                                pos++;
                                continue;
                            }
                        }
                        // Stop if we hit a comma or closing brace (and not in a string)
                        if (!inString && (char === ',' || char === '}')) {
                            break;
                        }
                        // Stop if we hit another field name (and not in a string)
                        if (!inString && char.match(/[A-Z]/)) {
                            const remaining = str.substring(pos);
                            if (remaining.match(/^(ReadingAndWriting|Math)\s*[:=]/)) {
                                break;
                            }
                        }
                        // Add character to content if we're inside a string
                        if (inString) {
                            content += char;
                        }
                        pos++;
                    }
                    return content.trim() || null;
                };
                // Extract ReadingAndWriting
                const readingContent = extractTemplateLiteral('ReadingAndWriting', smartAnalysis);
                if (readingContent) {
                    parsedSmartAnalysis.ReadingAndWriting = readingContent;
                }
                // Extract Math
                const mathContent = extractTemplateLiteral('Math', smartAnalysis);
                if (mathContent) {
                    parsedSmartAnalysis.Math = mathContent;
                }
            }
        }
        else {
            parsedSmartAnalysis = smartAnalysis;
        }
        console.log('smartAnalysis raw:', smartAnalysis);
        console.log('parsedSmartAnalysis:', parsedSmartAnalysis);
    }
    React.useEffect(() => { }, [flaggedQns]);
    return ((0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, spacing: 2 }, { children: [(expandedSection === null || expandedSection === 'left') && ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: expandedSection === 'left' ? 12 : 6 }, { children: (0, jsx_runtime_1.jsxs)(Paper_1.default, Object.assign({ sx: { width: '100%' } }, { children: [(0, jsx_runtime_1.jsxs)(Box_1.default, Object.assign({ display: 'flex', justifyContent: 'space-between', alignItems: 'center', sx: { p: 1 } }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ sx: { fontSize: '1.5vmax' } }, { children: (0, jsx_runtime_1.jsx)("b", { children: "Questions Overview" }) })), (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: () => setExpandedSection(expandedSection === 'left' ? null : 'left'), size: 'small' }, { children: expandedSection === 'left' ? (0, jsx_runtime_1.jsx)(CloseFullscreen_1.default, {}) : (0, jsx_runtime_1.jsx)(Fullscreen_1.default, {}) }))] })), (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ direction: 'column', spacing: 1 }, { children: [(0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, direction: 'column' }, { children: [(0, jsx_runtime_1.jsx)(Grid_1.default, { item: true, xs: true }), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: true, sx: { padding: '0 0.5vmax 0 0' } }, { children: (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ direction: 'row', justifyContent: 'space-between', className: 'result_grid_overview_stack' }, { children: [(0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ direction: 'column', spacing: 0, justifyContent: 'center', textAlign: 'center', sx: { width: '100%', p: 1 } }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ sx: { fontSize: '2vmax' } }, { children: total })), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ sx: { fontSize: '0.75vmax' } }, { children: "Total Questions" }))] })), (0, jsx_runtime_1.jsx)("div", { style: { margin: '1vmax 0', borderRight: '1px solid black' } }), (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ direction: 'column', spacing: 0, justifyContent: 'center', textAlign: 'center', sx: { width: '100%', p: 1 } }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ sx: { fontSize: '2vmax' } }, { children: correct })), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ sx: { fontSize: '0.75vmax' } }, { children: "Correct Answers" }))] })), (0, jsx_runtime_1.jsx)("div", { style: { margin: '1vmax 0', borderRight: '1px solid black' } }), (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ direction: 'column', spacing: 0, justifyContent: 'center', textAlign: 'center', sx: { width: '100%', p: 1 } }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ sx: { fontSize: '2vmax' } }, { children: total - correct })), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ sx: { fontSize: '0.75vmax' } }, { children: "Incorrect Answers" }))] }))] })) }))] })), (0, jsx_runtime_1.jsx)(Paper_1.default, Object.assign({ sx: { width: '100%' } }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ style: { height: '55vh', width: '100%', overflowY: 'auto' } }, { children: (0, jsx_runtime_1.jsx)(StyledDataGrid, { apiRef: apiRef, rows: rows, columns: columns, hideFooter: true, classes: { columnHeader: 'result_grid_header' }, slots: { toolbar: x_data_grid_1.GridToolbar }, slotProps: {
                                                toolbar: {
                                                    csvOptions: {
                                                        fileName: `${userName}-${testName}-${completeDate ? completeDate.replace(/\//g, '-') : ''}`,
                                                    },
                                                },
                                            } }) })) }))] }))] })) }))), (expandedSection === null || expandedSection === 'right') && ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: expandedSection === 'right' ? 12 : 6 }, { children: (0, jsx_runtime_1.jsxs)(Paper_1.default, Object.assign({ sx: { height: '100%', p: 2 } }, { children: [(0, jsx_runtime_1.jsxs)(Box_1.default, Object.assign({ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }, { children: [(0, jsx_runtime_1.jsxs)(Typography_1.default, Object.assign({ variant: 'h4', sx: { mb: 2, fontWeight: 'bold', display: 'flex', alignItems: 'center' } }, { children: ["Smart Analysis", (0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ title: 'BETA version', placement: 'right' }, { children: (0, jsx_runtime_1.jsx)("img", { src: '/assets/beta.png', alt: 'BETA', style: { height: 28, marginLeft: 8, cursor: 'pointer' } }) }))] })), (0, jsx_runtime_1.jsxs)(Box_1.default, Object.assign({ display: 'flex', alignItems: 'center' }, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: sendAnalysisData, size: 'small', sx: { mr: 1 } }, { children: (0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ title: 'Refresh to get latest analysis', placement: 'right' }, { children: (0, jsx_runtime_1.jsx)(Refresh_1.default, {}) })) })), (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: () => setExpandedSection(expandedSection === 'right' ? null : 'right'), size: 'small' }, { children: expandedSection === 'right' ? (0, jsx_runtime_1.jsx)(CloseFullscreen_1.default, {}) : (0, jsx_runtime_1.jsx)(Fullscreen_1.default, {}) }))] }))] })), smartLoading || !showSmartAnalysis ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' } }, { children: (0, jsx_runtime_1.jsx)("img", { src: '/assets/smartAI.gif', alt: 'Loading...' }) }))) : parsedSmartAnalysis && (parsedSmartAnalysis.ReadingAndWriting || parsedSmartAnalysis.Math) ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: { maxHeight: '65vh', overflowY: 'auto' } }, { children: (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ spacing: 2 }, { children: [parsedSmartAnalysis.ReadingAndWriting && ((0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ spacing: 1 }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'h6', sx: { fontWeight: 'bold' } }, { children: "Reading and Writing" })), (0, jsx_runtime_1.jsx)(Typography_1.default, { variant: 'body1', sx: { fontSize: '1rem' }, dangerouslySetInnerHTML: createMarkup(parsedSmartAnalysis.ReadingAndWriting) })] }))), parsedSmartAnalysis.Math && ((0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ spacing: 1 }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'h6', sx: { fontWeight: 'bold' } }, { children: "Math" })), (0, jsx_runtime_1.jsx)(Typography_1.default, { variant: 'body1', sx: { fontSize: '1rem' }, dangerouslySetInnerHTML: createMarkup(parsedSmartAnalysis.Math) })] })))] })) }))) : (feedback && ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: { maxHeight: '65vh', overflowY: 'auto' } }, { children: (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ spacing: 2 }, { children: [feedback['Reading & Writing'] && ((0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ spacing: 1 }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'h6', sx: { fontWeight: 'bold' } }, { children: "Reading & Writing" })), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'body1', sx: { fontSize: '1rem' } }, { children: feedback['Reading & Writing'] }))] }))), feedback['Math'] && ((0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ spacing: 1 }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'h6', sx: { fontWeight: 'bold' } }, { children: "Math" })), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'body1', sx: { fontSize: '1rem' } }, { children: feedback['Math'] }))] })))] })) }))))] })) }))), !((_x = data === null || data === void 0 ? void 0 : data.diagnostic) === null || _x === void 0 ? void 0 : _x.isBlueBookData) && ((0, jsx_runtime_1.jsx)(ReviewResult_1.default, { open: showReview, setOpen: () => setShowReview(false), quizId: parseInt((selected === null || selected === void 0 ? void 0 : selected.sectionId) || 0), questionOrder: parseInt((selected === null || selected === void 0 ? void 0 : selected.questionOrder) || 0), data: data, quiz: quiz, header: header })), (0, jsx_runtime_1.jsx)(Popover_1.default, Object.assign({ id: idpopup, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center',
                } }, { children: (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, spacing: 3, justifyContent: 'space-between', sx: { backgroundColor: 'transparent', padding: '2vh' } }, { children: [(0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ item: true, xs: 4, style: { justifyContent: 'center' } }, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, { edge: 'end', color: 'inherit', "aria-controls": 'menu', "aria-haspopup": 'true', sx: { width: '3vh', height: '3vh', backgroundColor: 'red', ':hover': { backgroundColor: 'red' } }, onClick: () => {
                                        handleFlagAction('help');
                                    } }), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ fontWeight: 'bold', textAlign: 'center' }, { children: "Help" }))] })), (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ item: true, xs: 4 }, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, { edge: 'end', color: 'inherit', "aria-controls": 'menu', "aria-haspopup": 'true', sx: { width: '3vh', height: '3vh', backgroundColor: 'orange', ':hover': { backgroundColor: 'orange' } }, onClick: () => {
                                        handleFlagAction('nudge');
                                    } }), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ fontWeight: 'bold', textAlign: 'center' }, { children: "Nudge" }))] })), (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ item: true, xs: 4 }, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, { edge: 'end', color: 'inherit', "aria-controls": 'menu', "aria-haspopup": 'true', sx: { width: '3vh', height: '3vh', backgroundColor: '#70D291', ':hover': { backgroundColor: '#70D291' } }, onClick: () => {
                                        handleFlagAction('gotit');
                                    } }), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ fontWeight: 'bold', textAlign: 'center' }, { children: "Got it" }))] }))] })) })), (0, jsx_runtime_1.jsx)(Snackbar_1.default, Object.assign({ autoHideDuration: 6000, onClose: handleSnackBarClose, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, open: alertOpen }, { children: (0, jsx_runtime_1.jsx)(Alert_1.default, Object.assign({ onClose: handleSnackBarClose, severity: 'error', variant: 'filled', sx: { width: '100%' } }, { children: alertMessage || 'No Guides available' })) })), pdfDialogOpen && ((0, jsx_runtime_1.jsxs)(Dialog_1.default, Object.assign({ open: pdfDialogOpen, onClose: handlePdfDialogClose, maxWidth: isMaximized ? false : 'lg', fullWidth: !isMaximized, fullScreen: isMaximized }, { children: [(0, jsx_runtime_1.jsx)(DialogTitle_1.default, { children: (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ direction: 'row', justifyContent: 'space-between', alignItems: 'center' }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'h6' }, { children: "Guide" })), (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ direction: 'row', alignItems: 'center', spacing: 1 }, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: handleToggleSize }, { children: isMaximized ? (0, jsx_runtime_1.jsx)(FullscreenExit_1.default, {}) : (0, jsx_runtime_1.jsx)(Fullscreen_2.default, {}) })), (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: handlePdfDialogClose }, { children: (0, jsx_runtime_1.jsx)(Close_1.default, {}) }))] }))] })) }), (0, jsx_runtime_1.jsx)(DialogContent_1.default, { children: (fileType === 'pdf' || fileType === 'docx' || fileType === 'xlsx') && ((0, jsx_runtime_1.jsx)("iframe", { src: pdfUrl, width: '100%', height: isMaximized ? '100%' : '600px', title: 'Viewer', style: { border: 'none' } })) })] })))] })));
};
exports.default = ResultGrid;
